import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { REVIEW_TYPE } from '../models';

@Pipe({
  name: 'reviewTypeFormatter',
  pure: false,
})
export class ReviewTypeFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: REVIEW_TYPE, ...args: any[]): any {
    if (!value) {
      return value;
    }

    let resultDate = this.getResult(value);

    this.translateService.onLangChange.subscribe(() => {
      resultDate = this.getResult(value);
    });

    return resultDate;
  }

  private getResult(value: REVIEW_TYPE): string {
    return this.translateService.instant(`pipes.review_type.${value}`);
  }
}
